const measurementId = (process.env.REACT_APP_GA_MEASUREMENT_ID || "").trim();
const validId = /^G-[A-Z0-9]+$/i.test(measurementId);

function ensureGtag() {
  if (!validId || typeof window === "undefined") return null;

  if (!window.dataLayer) window.dataLayer = [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector("script[data-ga4-gtag]")) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.dataset.ga4Gtag = "true";
    document.head.appendChild(script);
  }

  if (!window.__ga4Configured) {
    window.gtag("js", new Date());
    window.gtag("config", measurementId, { send_page_view: false });
    window.__ga4Configured = true;
  }

  return window.gtag;
}

export function initGA4() {
  ensureGtag();
}

export function trackGA4PageView() {
  const gtag = ensureGtag();
  if (!gtag) return;
  gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
  });
}
